import wx from 'weixin-js-sdk'
import { getJsApiTicket } from '@/services/api'
import { isMobileType } from '@/utils/isMobileType.js'

export function shareWX(companyId, url, option) {
  //option是分享的配置内容*/
  getJsApiTicket({ companyId, url }).then(res => {
    //请求后台接口
    wx.config({
      debug: false, //是否开启debug
      appId: res.appId, //你的appid
      timestamp: res.timestamp, //时间戳
      nonceStr: res.noncestr, //随机字符串
      signature: res.signature, //秘钥
      jsApiList: [
        //请求的api接口列表，微信的，详情去看微信官方文档
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'getLocation',
        'openLocation',
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
      ],
    })
    wx.ready(function () {
      //如果wx.config配置正常，会自动走此处
      console.log('ready执行完毕')
      if (isMobileType.iOS()) {
        //获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
        wx.onMenuShareAppMessage({
          title: option.shareTitle, // 分享标题
          desc: option.shareDesc, // 分享描述
          link: option.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: option.shareImg, // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
          },
        })
      }
      //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title: option.shareTitle, //分享的标题
        desc: option.shareDesc, //分享的描述信息
        link: option.shareUrl, //分享的url
        imgUrl: option.shareImg, //分享的图片
        success: function () {
          // 设置成功
        },
      })
      //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分
      // wx.updateTimelineShareData({
      //     title: option.shareTitle,
      //     desc: option.shareDesc,
      //     link: option.shareUrl,
      //     imgUrl: option.shareImg,
      // });
    })
    wx.error(function (res) {
      //如果wx.config配置失败,会走到此处
      console.log('error', res)
    })
  })
}
